import React from "react";

export default function LegalLayout({ title, updatedOn, children }) {
  return (
    <>
      <section
        className="text-white"
        style={{ background: "linear-gradient(105deg,#0F2B46 0%,#196CA3 100%)" }}
      >
        <div className="mx-auto max-w-3xl px-5 lg:px-8 py-14">
          <div className="rule" style={{ background: "#4FC3F7" }} />
          <div className="eyebrow !text-brand-light">Legal</div>
          <h1 className="mt-3 text-3xl sm:text-4xl font-extrabold leading-tight tracking-tight">
            {title}
          </h1>
          {updatedOn && (
            <p className="mt-3 text-brand-pale text-sm">Last updated: {updatedOn}</p>
          )}
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto max-w-3xl px-5 lg:px-8 py-16">
          <div className="prose-legal">{children}</div>
        </div>
      </section>
    </>
  );
}
